<template>
	<div class="meetingSpace-wrap">
		<!--    <p class="name">-->
		<!--      {{   name }}-->
		<!--    </p>-->
		<div class="select-list">
			<el-select v-model="state.value" multiple :placeholder="props.placeholder" size="large" style="display: block;width: 100%;font-size: 0.83333vw;line-height: 1.64583vw;
                 " @change="emit('changeRoom', state.value)">
				<el-option v-for="item in props.data" :key="item.id" :label="item.province + '/' + item.area +':' + item.name
                    + (item.price ? '(' + item.price / 100 + item.currency + '/小时)': '')
                    + (item.remark ? '(' + item.remark + ')': '')" :value="item.id" />
			</el-select>
			<!--      <select name="city" id="city">-->
			<!--        <option value="">请选择省份</option>-->
			<!--        <option value="0">北京</option>-->
			<!--        <option value="0">上海</option>-->
			<!--        <option value="0">大连</option>-->
			<!--      </select>-->
			<!--      <select name="address" id="address">-->
			<!--        <option value="">请选择详细位置</option>-->
			<!--        <option value="0">19楼202号</option>-->
			<!--        <option value="0">19楼203号</option>-->
			<!--        <option value="0">19楼204号</option>-->
			<!--      </select>-->
		</div>
	</div>
</template>

<script setup>
	import {
		ref,
		reactive,
		watch
	} from "vue";
	const emit = defineEmits();

	const props = defineProps({
		name: String,
		placeholder: String,
		data: Array,
		selectData: {
			type: Array,
			default: []
		}
	})
	const state = reactive({
		value: []
		// options: [
		//   {
		//     value: 'Option1',
		//     label: '北京19楼202号',
		//   }
		// ]
	})

	// 监听数据
	watch(props, (newValue, oldValue) => {
		state.value = newValue.selectData
	})
</script>

<style lang="less" scoped>
	::v-deep .el-input--large .el-input__wrapper {
		padding-left: 0;
	}

	::v-deep .el-select .el-input__inner {
		// height: auto !important;
		// line-height: 1.14583vw;
		padding: 0.72916vw 1.25vw;
		box-sizing: border-box;
		font-size: 0.83333vw;
	}

	.meetingSpace-wrap {
		width: 30.20833vw;
		margin: 0 auto;

		.name {
			font-size: 0.9375vw;
			line-height: 1.30208vw;
			font-weight: bold;
			color: #2F3367;
			margin-bottom: 0.41666vw;
		}

		.select-list {
			width: 100%;

			select {
				display: block;
				width: 100%;
				font-size: 0.83333vw;
				line-height: 1.14583vw;
				box-sizing: border-box;
				border: 0.05208vw solid #D4D6D8;
				border-radius: 0.20833vw;
				padding: 0.72916vw 1.25vw;
				background: url("../../assets/img/icons/icon-arr-down.png") no-repeat;
				background-size: 1.14583vw 1.04166vw;
				background-position: right 1.25vw center;
				transition: border-color .2s cubic-bezier(0.645, 0.045, 0.355, 1);
				margin-bottom: 0.83333vw;

				&:last-child {
					margin-bottom: 0;
				}

				&[value=''] {
					color: #ccc;
				}
			}

		}
	}

	@media screen and (max-width: 750px) {
		::v-deep .el-input--large .el-input__wrapper {
			padding-left: 0;
		}

		::v-deep .el-select .el-input__inner {
			//height: auto !important;
			//line-height: 5.33333vw;
			padding: 2.66666vw 3.2vw;
			box-sizing: border-box;
			font-size: 3.73333vw;
		}

		.meetingSpace-wrap {
			width: 82.93333vw;

			.name {
				font-size: 3.73333vw;
				line-height: 5.33333vw;
				margin-bottom: 1.6vw;
			}

			.select-list {
				width: 100%;

				select {
					font-size: 3.73333vw;
					line-height: 5.33333vw;
					padding: 2.66666vw 3.2vw;
					background-size: 4.26666vw;
					border-radius: 0.53333vw;
					border-width: 0.13333vw;
					margin-bottom: 3.2vw;

					&:last-child {
						margin-bottom: 0;
					}
				}
			}
		}


	}
</style>
